import ImgOg from 'assets/images/la-Freebie-cover.jpg'
import { Layout, Main } from 'layout'
import { canonicalUrl } from 'lib/utils'
import Head from 'next/head'
import PageContent from 'pageContent/LAFahrplanSelbstliebe'
import { CSSProperties } from 'react'

import type { NextPage } from 'next'

const hiddenStyles = {
  display: 'none',
  opacity: 0,
  width: 0,
  height: 0,
  position: 'absolute',
  pointerEvents: 'none'
}

const AngebotePrivatpersonen: NextPage = () => (
  <>
    <Layout>
      <Head>
        <title>Fahrplan Selbstliebe | FrauenCoach.jetzt</title>
        <meta
          name="description"
          key="description"
          content={`Hol dir jetzt den Schlüssel für deinen einfachen Start in die Selbstliebe`}
        />
        <meta
          name='keywords'
          key='keywords'
          content={`Coaching Berlin, Coach Privatpersonen, Coach Frauen, Frauencoach, Coach für Frauen, Onlinekurs, Kurs, LebensArt, Online-Akademie, Online-Akademie LebensArt`}
        />
        <meta key="ogImage" property="og:image" content={ImgOg?.src} />
        <meta key="twitterImage" property="twitter:image" content={ImgOg?.src} />

        <link key="canonical" rel="canonical" href={canonicalUrl('/lebensart-akademie')} />

        {/* Sendinblue */}
        <link rel="stylesheet" href="https://sibforms.com/forms/end-form/build/sib-styles.css"></link>
      </Head>
      <Main>
        <PageContent />
      </Main>
    </Layout>
    <div
      style={hiddenStyles as CSSProperties}
      dangerouslySetInnerHTML={{ __html: `
  <script>
  window.REQUIRED_CODE_ERROR_MESSAGE = 'Wählen Sie bitte einen Ländervorwahl aus.';
  window.LOCALE = 'de';
  window.EMAIL_INVALID_MESSAGE = window.SMS_INVALID_MESSAGE = "Die eingegebenen Informationen sind nicht gültig. Bitte überprüfe das Feldformat und versuche es erneut.";

  window.REQUIRED_ERROR_MESSAGE = "Dieses Feld darf nicht leer sein. ";

  window.GENERIC_INVALID_MESSAGE = "Die eingegebenen Informationen sind nicht gültig. Bitte überprüfe das Feldformat und versuche es erneut.";




  window.translation = {
    common: {
      selectedList: '{quantity} Liste ausgewählt',
      selectedLists: '{quantity} Listen ausgewählt'
    }
  };

  var AUTOHIDE = Boolean(0);
  </script>
  <script defer src="https://sibforms.com/forms/end-form/build/main.js"></script>

  <script src="https://www.google.com/recaptcha/api.js?hl=de"></script>
      ` }}
    />
  </>
)

export default AngebotePrivatpersonen
